import React from "react";
import { FaLock, FaMoneyBillWave, FaShippingFast, FaTag } from "react-icons/fa";

const slogans = [
  {
    icon: <FaLock size={24} className="text-black" />,
    text: "Kalıcı Veri Temizliği",
  },
  {
    icon: <FaMoneyBillWave size={24} className="text-black" />,
    text: "Hızlı Ödeme",
  },
  {
    icon: <FaShippingFast size={24} className="text-black" />,
    text: "Ücretsiz Kargo",
  },
  { icon: <FaTag size={24} className="text-black" />, text: "En İyi Fiyat" },
];

const SloganRow = () => {
  return (
    <div className="w-full bg-gray-50 py-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-4 relative text-center text-black gap-6">
          {slogans.map((item, index) => (
            <div className="flex flex-row items-center space-x-4 justify-center relative">
              <div className="text-black text-2xl transition-all duration-300 hover:text-gray-700 hover:scale-110">
                {item.icon}
              </div>

              <h3 className="text-lg font-semibold">{item.text}</h3>

              {index !== slogans.length - 1 && (
                <div className="absolute right-0 top-[50%] transform -translate-y-1/2 h-12 w-[1px] bg-gray-400 hidden sm:block"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SloganRow;
